import React from 'react';

const Footer = () => {
	return (
		<div className='h-20 bg-green-400 flex justify-center items-end'>
			<h1 className='mb-4'>&copy;All Rights Reserved</h1>
		</div>
	);
};

export default Footer;
